import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarVerracos/descargarPlantillaExcelVerracos`, method: 'GET', body: null, token: token})
}
